import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { State } from "../state/types";
import { StepName } from "components/Signup/steps/types";

export const navigationSlice = createSlice({
  name: "navigation",
  initialState: {} as State["navigation"],
  reducers: {
    goToNextStep: (
      state,
      _action: PayloadAction<{ replace: boolean; overrideStep?: StepName }>
    ) => {
      state.isTransitioning = true;
    },
    goToPreviousStep: (state, _action: PayloadAction<{ replace: boolean }>) => {
      state.isTransitioning = true;
    },
    updateActiveStep: (state, action: PayloadAction<StepName>) => {
      // Don't navigate away from the thank you page. Instead the MW will reset you
      state.activeStep =
        state.activeStep === "thank-you" ? state.activeStep : action.payload;
      state.isTransitioning = false;
    },
    hydrateStep: (state, action: PayloadAction<StepName>) => {
      return state;
    },
    updateNavigation: (
      state,
      action: PayloadAction<Partial<State["navigation"]>>
    ) => {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
});

export const {
  goToNextStep,
  updateActiveStep,
  goToPreviousStep,
  updateNavigation,
  hydrateStep,
} = navigationSlice.actions;

export const navigationReducer = navigationSlice.reducer;
